export const LOG_ERROR_MESSAGE = 'LOG_ERROR_MESSAGE'

export function logError(message) {
  return {
    type: LOG_ERROR_MESSAGE,
    payload: { message }
  }
}
